import React, {Component} from 'react';
import { Switch, Route, Link, Redirect, BrowserRouter as Router } from 'react-router-dom'
import '../CSS/Template.css'
import logo from '../images/logo.png'
import LeftMenu from "../Components/LeftMenu.js"

export default class Footer extends Component {
  render() {
    return (
      <div id="footer" className="footer">
      {this.props.unread == true &&
           <center><p>Message Spiffy (1)</p></center>
       }
       {this.props.unread == false &&
            <center><p>Message Spiffy</p></center>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/Footer.js